<template lang="pug">
#episode.container-fluid.px-0
  b-modal#share(centered, hide-header, hide-footer, size="lg")
    template
      p.title Compartir
      social-sharing#social-sharing.mt-5(
        url="https://defensoresdelademocracia.mx/voces-silenciadas",
        title="VOCES SILENCIADAS",
        description="ARENAS MOVEDIZAS - En un estado tan violento como Veracruz, hay varias razones para matar, pero ¿por qué matan a un periodista?",
        quote="ARENAS MOVEDIZAS - En un estado tan violento como Veracruz, hay varias razones para matar, pero ¿por qué matan a un periodista?",
        hashtags="periodistas, DDLD_MX",
        twitter-user="DDLD_MX",
        inline-template
      )
        .row.d-flex.justify-content-center
          network.col-2.d-flex.justify-content-center.align-items-center(
            network="facebook"
          )
            i.fab.fa-facebook
          network.col-2.d-flex.justify-content-center.align-items-center(
            network="twitter"
          )
            i.fab.fa-twitter
          network.col-2.d-flex.justify-content-center.align-items-center(
            network="whatsapp"
          )
            i.fab.fa-whatsapp
          network.col-2.d-flex.justify-content-center.align-items-center(
            network="telegram"
          )
            i.fab.fa-telegram
          network.col-2.d-flex.justify-content-center.align-items-center(
            network="email"
          )
            i.fas.fa-envelope
  b-modal#subscribe(centered, hide-header, hide-footer, size="lg")
    template
      p.title Suscribir
      .row.d-flex.justify-content-center.mt-5
        .col-2.d-flex.justify-content-center.align-items-center
          a(
            href="https://open.spotify.com/show/2ciLR4Rp6L8ss5nceblk3U?si=eSN5m0lMRb28FdSg75k3Hw",
            target="_blank"
          )
            i.fab.fa-spotify
        .col-2.d-flex.justify-content-center.align-items-center
          a(
            href="https://www.breaker.audio/voces-silenciadas",
            target="_blank"
          )
            img.breaker(src="/img/breaker.svg")
        .col-2.d-flex.justify-content-center.align-items-center
          a(
            href="https://radiopublic.com/voces-silenciadas-GbpqDx/s1!01913",
            target="_blank"
          )
            img.radiopublic(src="/img/radiopublic.svg")
        .col-2.d-flex.justify-content-center.align-items-center
          a(
            href="https://podcasts.google.com/?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy8xNDhkMzg0NC9wb2RjYXN0L3Jzcw%3D%3D",
            target="_blank"
          )
            i.fab.fa-google
        .col-2.d-flex.justify-content-center.align-items-center
          a(href="https://anchor.fm/voces-silenciadas", target="_blank")
            img.anchor(
              src="https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-header.png"
            )
  #top.row
    .audio.col-12.pl-0.pr-4
      audio#episode(src="/audio/VS_Monlui_20200226.mp3", controls)
    .hero.col-12.p-0
      h2.season.mt-3.px-2 TEMPORADA 1
      h2.logo.mt-3.px-2
        span.d-block DEFENSORES DE
        span.d-block LA DEMOCRACIA
      //.episode.d-flex.flex-row
        i.far.fa-play-circle.mr-3(@click="playAudio()")
        h2.mt-2
          span.d-block EPISODIO 01
          span.d-block.name ARENAS MOVEDIZAS
      //video(playsinline muted autoplay)
        source(type="video/mp4" src="/video/podcast1.mp4")
      //img.video.col-12.p-0(src="/video/podcast1.gif")
      //img.image.col-12.p-0(src="/img/illustration1.png")
    .submenu.row.p-5
      .col-12.col-lg-4.left
        .row
          .col-12.d-flex.flex-row
            i.fas.fa-play-circle.mr-3(@click="playAudio()")
            h5.mt-3.ml-2 EPISODIO 01
          .col-12.d-flex.flex-row
            p.mb-5 __________________________
          .col-12.d-flex.flex-row
            i.fas.fa-rss.mr-4
            a(href="javascript:void(0);", v-b-modal.subscribe)
              p.mb-4 SUSCRÍBETE
          .col-12.d-flex.flex-row
            i.fas.fa-download.mr-4
            a(href="/audio/VS_Monlui_20200226.mp3", target="_blank")
              p.mb-4 DESCARGA
          .col-12.d-flex.flex-row
            i.fas.fa-align-left.mr-4
            router-link(
              to="/voces-silenciadas/1/arenas-movedizas/transcripcion"
            )
              p.mb-4 TRANSCRIPCIÓN
          .col-12.d-flex.flex-row
            i.fas.fa-external-link-alt.mr-4
            a(href="javascript:void(0);", v-b-modal.share)
              p.mb-0 COMPARTE
      .col-12.col-lg-8.right.pt-5.pt-lg-0
        .row
          .col-12
            h1.mb-5 ARENAS MOVEDIZAS
          .col-12
            p.mb-5 En un estado tan violento como Veracruz, hay varias razones para matar, pero ¿por qué matan a un periodista?
          //.col-12.d-flex.flex-row.transcript
            i.fas.fa-align-left.mr-4
            router-link(to="/voces-silenciadas/1/arenas-movedizas")
              p.mb-4 PÁGINA DE EPISODIO
          .col-12.related
            p RELACIONADO
          .col-12.profile.pt-2
            router-link(to="/periodista/Ricardo-Monlui-Cabrera")
              p.mb-0 Ir al perfil de Ricardo Monluí Cabrera
          .col-12
            p.mb-0 ____________________________________________________________________________
          .col-12
            //p.mb-0 Acerca del Episodio 01 &nbsp;&#8594;
  #middle
    .grid.p-5
      .row
        .col-12.title
          p.text-center.mb-1 MATERIAL EXTRA
        .col-12
          p.text-center.mb-5 ____________________________________________________________________________
      .row.px-lg-5
        a.col-12.col-lg-4.post(:href="p.link" v-for="p in episodePosts")
          p.mb-2.post-title {{p.title.rendered}}
          p.author {{p.autor}}
          p.description {{p.descripcion}}

  #bottom
    .footer
      .row.d-flex.justify-content-center.align-items-center.pt-5
        a.newsletter.pt-4(
          href="http://us4.forward-to-friend.com/forward?u=4767ec3be327d489ec56e66c9&id=b6cd7e4a41&e=",
          target="_blank"
        )
          p.text-justify.mb-0 SUSCRÍBETE AL NEWSLETTER
      .row.logos.d-flex.justify-content-center.align-items-center.mt-5
        img(src="/img/ddld_logo.png")
</template>

<script>
export default {
  computed: {
    episodePosts: {
      get() {
        return this.$store.state.episodePosts;
      },
      set(newValue) {
        this.$store.state.episodePosts = newValue;
      },
    },
  },
  methods: {
    playAudio() {
      const audio = document.getElementById("episode");
      audio.play();
    },
    async getEpisodePosts() {
      await this.$store.dispatch("getEpisodePosts");
    },
  },
  mounted() {
    this.getEpisodePosts();
  },
};
</script>

<style lang="scss">
#share {
  @media (max-width: 767.98px) {
    .modal-content {
      border-radius: 0px !important;
      padding: 10px !important;
    }
  }
  .modal-content {
    background-color: #000000ee;
    border-radius: 0px;
    color: white;
    padding: 50px;
    .title {
      font-size: 30px;
    }
    .text,
    ul {
      font-size: 15px;
    }
  }
}

#subscribe {
  @media (max-width: 767.98px) {
    .modal-content {
      border-radius: 0px !important;
      padding: 10px !important;
    }
  }
  .modal-content {
    background-color: #000000ee;
    border-radius: 0px;
    color: white;
    padding: 50px;
    .title {
      font-size: 30px;
    }
    .text,
    ul {
      font-size: 15px;
    }
    a {
      color: white;
      .breaker {
        width: 16px;
      }
      .radiopublic {
        width: 50px;
      }
      .anchor {
        width: 60px;
      }
    }
  }
}

#episode {
  .row {
    margin: 0;
  }
  #top {
    //height: 100%;
    .audio {
      z-index: 100;
      height: 5vh;
      background-color: #f2f3f4;
      position: sticky;
      top: 0;
      z-index: 100;
      audio {
        height: 5vh;
        width: 98vw;
      }
    }
    .hero {
      height: 785px;
      position: relative;
      background-image: url("/img/illustration1.png");
      background-size: cover;
      .season {
        z-index: 10;
        position: absolute;
        left: 30px;

        color: white;
        letter-spacing: 4px;
        @media (min-width: 993px) {
          font-size: 32px;
        }
        @media (max-width: 992px) {
          font-size: 14px;
        }
      }
      .logo {
        z-index: 10;
        position: absolute;
        right: 30px;
        color: transparent;
        -webkit-text-stroke: 1px #fff;
        @media (min-width: 993px) {
          font-size: 32px;
        }
        @media (max-width: 992px) {
          font-size: 14px;
        }
      }
      .episode {
        z-index: 10;
        position: absolute;
        left: 10%;
        bottom: 50px;

        color: white;
        i {
          letter-spacing: 4px;
          @media (min-width: 993px) {
            font-size: 70px;
          }
          @media (max-width: 992px) {
            font-size: 30px;
          }
        }
        h2 {
          letter-spacing: 4px;
          @media (min-width: 993px) {
            font-size: 50px;
          }
          @media (max-width: 992px) {
            font-size: 18px;
          }
          .name {
            letter-spacing: 4px;
            @media (min-width: 993px) {
              font-size: 18px;
            }
            @media (max-width: 992px) {
              font-size: 13px;
            }
          }
        }
      }
      .video {
        z-index: 0;
        /*object-fit: fill;
        @media (min-width: 993px) {
          width: 100%;
        }
        @media (max-width: 992px) {
          width: 400px;
        }*/
      }
      .image {
        z-index: 0;
        /*object-fit: fill;
        @media (min-width: 993px) {
          width: 100%;
        }
        @media (max-width: 992px) {
          width: 400px;
        }*/
      }
    }
    .submenu {
      background-color: white;
      color: #0a0a0a;
      .left {
        font-size: 15px;
        letter-spacing: 4px;
        .fa-play-circle {
          letter-spacing: 4px;
          font-size: 60px;
          color: #920d00;
        }
        a {
          color: #0a0a0a;
        }
        p {
          font-weight: bold;
        }
      }
      .right {
        .transcript {
          letter-spacing: 4px;
          a {
            color: #0a0a0a;
          }
        }
        .related {
          letter-spacing: 4px;
          color: #920d00;
        }
        .profile {
          a {
            color: black;
            font-weight: bold;
          }
        }
      }
    }
  }
  #middle {
    .grid {
      .title {
        font-size: 35px;
        color: black;
        letter-spacing: 4px;
      }
      .post {
        color: #0a0a0a;
        .post-title {
          font-size: 17px;
          font-weight: bold;
        }
        .author {
          font-size: 15px;
          font-weight: bold;
          text-decoration: underline;
        }
        .description {
          font-size: 15px;
        }
      }
    }
  }
  #bottom {
    .footer {
      height: 300px;
      background-color: #ebebeb;
      .newsletter {
        p {
          color: black;

          font-size: 25px;
          letter-spacing: 4px;
        }
      }
      .logos {
        img {
          height: 80px;
          width: auto;
        }
      }
    }
  }
}
</style>
